module.exports = __webpack_public_path__ + "img/profile-c.c0c32403.svg";